import React, { createContext, useState } from 'react'
import { CourseMeta } from 'types/data'

export interface VideoContextProps {
  isModalOpen: boolean
  courseMetaForVideo: CourseMeta | null
  openVideo: (courseMeta: CourseMeta) => void
  closeVideo: () => void
}

const VideoContext = createContext<VideoContextProps>({
  isModalOpen: false,
  openVideo: () => {},
  closeVideo: () => {},
  courseMetaForVideo: null,
})
export default VideoContext

type ProviderProps = {
  children?: React.ReactNode
}

export const VideoContextProvider = ({ children }: ProviderProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [courseMetaForVideo, setCourseMetaForVideo] =
    useState<CourseMeta | null>(null)

  const openVideo = (courseMeta: CourseMeta) => {
    setIsModalOpen(true)
    setCourseMetaForVideo(courseMeta)
  }

  const closeVideo = () => {
    setIsModalOpen(false)
    setCourseMetaForVideo(null)
  }

  return (
    <VideoContext.Provider
      value={{
        isModalOpen,
        courseMetaForVideo,
        openVideo,
        closeVideo,
      }}
    >
      {children}
    </VideoContext.Provider>
  )
}
